import React from "react"
import {Hole, TeamRoundPlayer} from "../../types";
import {strokesForHole, holeMaxStrokes} from "../../util";
import {sparkOrange} from "../../colors"

interface PlayerProps {
  player: TeamRoundPlayer,
  selected: boolean,
  hole: Hole,
  score: number | null,
  savedScore: number | null,
  toggleKeyboard: (player: TeamRoundPlayer) => void
}

export default function Player({ player, selected, hole, score, savedScore, toggleKeyboard }: PlayerProps) {
  const strokes = strokesForHole(player.handicapStrokes, hole.handicap)
  const max = holeMaxStrokes(hole.par, strokes)

  let displayScore = null

  if(score === null) {
    displayScore = savedScore
  } else if (score) {
    displayScore = score
  }

  return (
    <div
      style={{
        margin: "1rem 0",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
      }}
      onClick={() => toggleKeyboard(player)}
    >
      <div>
        <div style={{ fontWeight: "bold" }}>{player.user.name}</div>
        <div style={{ fontSize: "0.875rem" }}>
          {strokes > 0
            ? <span>{strokes} {strokes === 1 ? "stroke" : "strokes"} / </span>
            : null
          }
          <span>Max score: {max}</span>
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
          padding: "0.5rem",
          border: `${selected ? 2 : 1}px solid ${selected ? sparkOrange : "#cccccc"}`,
          borderRadius: "0.25rem",
          width: 52,
          height: 40
        }}
      >
        {displayScore > 0 && strokes > 0
          ? <span><strong>{displayScore}</strong>/<span style={{ color: "#666" }}>{displayScore - strokes}</span></span>
          : displayScore
        }
      </div>
    </div>
  )
}
